import axios from 'axios'
import { authenticationInterceptor } from 'API/interceptors/authenticationInterceptor'
import { csrfInterceptor } from 'API/interceptors/csrfInterceptor'
import { keyFormatterInterceptor } from 'API/interceptors/keyFormatterInterceptor'
import { schemaValidationInterceptor } from 'API/interceptors/schemaValidationInterceptor'
import { responseErrorStatusInterceptor } from 'API/interceptors/responseStatusInterceptor'
import { JSONSchema6 } from 'json-schema'
import defaultOptions from 'API/options/request/defaultOptions'

declare module 'axios' {
  export interface AxiosRequestConfig {
    schema?: JSONSchema6
  }
}

const irisHttpClient = axios.create({
  baseURL: import.meta.env.VITE_IRISAPI_HOST + import.meta.env.VITE_IRISAPI_BASEPATH,
  ...defaultOptions,
})

irisHttpClient.interceptors.request.use(authenticationInterceptor)
irisHttpClient.interceptors.request.use(csrfInterceptor)
irisHttpClient.interceptors.response.use((response) => response, responseErrorStatusInterceptor)
irisHttpClient.interceptors.response.use(keyFormatterInterceptor)
irisHttpClient.interceptors.response.use(schemaValidationInterceptor)

export default irisHttpClient
